import { IFindUserInformation } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { GET_INVOICES } from "../../routes";

const findInvoices = async (props: IFindUserInformation) => {
  var thisUrl = "";
  if (props?.serviceId) thisUrl = `?serviceId=${props.serviceId}`;

  let body: any = {};

  if (props?.serviceId) {
    try {
      return (await customAxios.get(GET_INVOICES + thisUrl, body)).data;
    } catch (error: any) {
      console.log({ GET_ALL_SCHOOL: error });
    }
  }
};

export default findInvoices;
